module.exports = __webpack_public_path__ + "static/img/chengcai4.32c4b62.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chengcai4.png
// module id = aDxf
// module chunks = 52